import Icon from '../../../components/AppIcon';

const StepIndicator = ({ currentStep, totalSteps, steps }) => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        {steps?.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;

          return (
            <div key={stepNumber} className="flex items-center flex-1">
              <div className="flex flex-col items-center flex-1">
                <div
                  className={`
                    w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center
                    transition-smooth font-semibold text-sm md:text-base
                    ${isCompleted
                      ? 'bg-success text-success-foreground'
                      : isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-muted-foreground'
                    }
                  `}
                >
                  {isCompleted ? (
                    <Icon name="Check" size={20} />
                  ) : (
                    <span>{stepNumber}</span>
                  )}
                </div>
                <span
                  className={`
                    mt-2 text-xs md:text-sm font-medium text-center
                    ${isActive ? 'text-foreground' : 'text-muted-foreground'}
                  `}
                >
                  {step?.label}
                </span>
              </div>
              {stepNumber < totalSteps && (
                <div
                  className={`
                    h-[2px] flex-1 mx-2 transition-smooth
                    ${isCompleted ? 'bg-success' : 'bg-border'}
                  `}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;